import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {GroupPayorMappingComponent} from './group-payor-mapping.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { GridModule, ColumnChooserService, PageService, SortService, FilterService ,ResizeService} from '@syncfusion/ej2-angular-grids';
import { MyDatePickerModule}  from 'mydatepicker';
import { NumericTextBoxModule, NumericTextBoxAllModule } from '@syncfusion/ej2-angular-inputs';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { dropdownModule } from 'src/app/dropdown/dropdown.module';
import { GroupPayorMappingRoutingModule } from './group-payor-mapping-routing.module';

@NgModule({
  declarations: [GroupPayorMappingComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    NgSelectModule,
    MyDatePickerModule,
    NumericTextBoxModule,
    NumericTextBoxAllModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    GroupPayorMappingRoutingModule,
    dropdownModule
  ],
  providers: [DatePipe,ColumnChooserService,PageService,SortService,FilterService,ResizeService],
})
export class GroupPayorMappingModule { }
